import { MIMIR_JWT_HTTP_HEADER } from '../util/constants';

interface NativeJwtToken {
  type: 'NativeJwtToken'
  jwtSecret: string;
}

// TODO: Add CustomerProvidedCredential and ApiKeyCredential
export type AuthTokenValue = NativeJwtToken;

export function httpClientMimirJwtAuthHeaderDict(token: AuthTokenValue): Record<string, string> {
  return {
    [MIMIR_JWT_HTTP_HEADER]: token.jwtSecret
  };
}

export function httpClientMimirJwtAuthHeaderArray(token: AuthTokenValue): [string, string][] {
  return [
    [MIMIR_JWT_HTTP_HEADER, token.jwtSecret]
  ];
}

/**
 * TODO: Replace with wsClientAuthUrl(), since we only want one way to pass
 * authentication for a given endpoint, and the browser is unable to send the
 * JWT through headers for the WebSocket.
 */
export function wsClientMimirJwtAuthHeaderDict(token: AuthTokenValue): Record<string, string> {
  return {
    [MIMIR_JWT_HTTP_HEADER]: token.jwtSecret
  };
}

